import React, {useState} from 'react';
import ItemTile from './SearchGallery/ItemTile';
import InventorySidebar from './InventorySidebar/InventorySidebar';
import NoInventory from './SearchGallery/NoInventory';

const InventoryGallery = ({inventoryList, pageContext, facets}) => {
    const [sidebar, setSidebar] = useState(false);

    if (inventoryList.length < 1){
        return <NoInventory/>
    }

    return <div>
        <div className='container searchPage'>
            <div className='search'>
                <div className={`mobileSidebar ${sidebar && "isOpen"}`}>
                    <div className='mobileSidebar-header'>
                        <div >Inventory</div>
                        <button onClick={() => setSidebar(!sidebar)} className='filterClose-btn'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-bar-left" viewBox="0 0 16 16">
                                <path fillRule="evenodd" d="M12.5 15a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5zM10 8a.5.5 0 0 1-.5.5H3.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L3.707 7.5H9.5a.5.5 0 0 1 .5.5z"/>
                            </svg>
                        </button>
                    </div>
                    
                    <InventorySidebar facets={facets} />
                </div>
                <div className='mobile-hidden'>
                    <InventorySidebar facets={facets} />
                </div>
                <div>
                    <h1>{pageContext.pageTitle}</h1>
                    <div className='searchMenu'>
                        <button className='filter-btn' onClick={() => setSidebar(!sidebar)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-filter" viewBox="0 0 16 16">
                                <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"/>
                            </svg> Filter
                        </button>
                        <h2>{`${inventoryList.length} result${inventoryList.length > 1 ? 's' : ''}`}</h2>
                    </div>
                    <div className='searchContainer'>
                        {inventoryList.map((inventoryItem) => <ItemTile item={inventoryItem} key={`item${inventoryItem.id}`}/>)}
                    </div>                    
                </div>
            </div>
        </div>      
    </div>
}

export default InventoryGallery;